'use client';

import { c as _c } from "react/compiler-runtime";
import type { Offer } from '@repo/contracts/marketplace/offers/types';
import { css } from '@repo/pandacss/css';
import { useEffect, useState } from 'react';
import { useSubmittedAnswers } from '@/entities/answer/model/hooks';
import { useFunnelFlattenedConfig } from '@/features/funnel/model/Context/hooks';
import { useRecommendations } from '@/features/recommendations/model/useRecommendations';
import { Card } from './Card';
import { MOBILE_RECOMMENDATION_COUNT } from './constants';
import { DetailsModal } from './DetailsModal';
export function RecommendationList() {
  const $ = _c(17);
  const submittedAnswers = useSubmittedAnswers();
  const funnelFlattenedConfig = useFunnelFlattenedConfig();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      isResultsPage: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const recommendations = useRecommendations(funnelFlattenedConfig, t0);
  const [selectedOffer, setSelectedOffer] = useState(null);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setSelectedOffer(null);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== submittedAnswers) {
    t2 = [submittedAnswers];
    $[2] = submittedAnswers;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (recommendations.length === 0) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      display: "flex",
      flexDirection: "row",
      gap: {
        base: "2",
        sm: "3"
      },
      justifyContent: {
        base: "space-evenly",
        sm: "flex-start"
      },
      pb: "3",
      overflowX: "auto",
      listStyle: "none",
      padding: "0",
      margin: "0"
    });
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== recommendations) {
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = (offer, index) => <li key={offer.id} className={css({
        display: "flex",
        flex: "1",
        minWidth: "[0]"
      })}><Card rank={index + 1} offer={offer} onOpenDetails={setSelectedOffer} /></li>;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t4 = recommendations.slice(0, MOBILE_RECOMMENDATION_COUNT).map(t5);
    $[5] = recommendations;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <ul id="mobile-recommendations-cards" className={t3}>{t4}</ul>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setSelectedOffer(null);
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== selectedOffer) {
    t7 = <DetailsModal offer={selectedOffer} onClose={t6} />;
    $[12] = selectedOffer;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <>{t5}{t7}</>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}